export enum Roles {
    'ADMINISTRADOR' = 1,
    'EMPLEADO' = 2,
    'VISITANTE' = 3
}